import { render, staticRenderFns } from "./PortalNodeUpdate.vue?vue&type=template&id=a09768aa"
import script from "./PortalNodeUpdate.ts?vue&type=script&lang=ts"
export * from "./PortalNodeUpdate.ts?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports